import React from 'react'
import {ButtonGroup, Row, Col} from "react-bootstrap";
import User from "./../User";
import Credit from "./../Credit";
import CreditMobile from "./../Credit/Mobile";
import Logo from "./../Logo";
import Favicon from "./../Logo/favicon";
import Chat from "./../Chat";
import RealTime from "./../RealTime";
import MobileMenu from "./../Menu/MobileMenu";

import Wallet from "../../../Components/User/Wallet";
import Notifications from "./../Notification";
import {isMobile, Event, BRAND} from "../../../../Helper";

class Header extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            header: null,
            show: true
        }
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize(){
        if(!isMobile()){
            this.setState({ header: this.desktop() })
        }
        else {
            this.setState({ header: this.mobile() })
        }
    }

    collapse = () =>{
        this.setState({ show: !this.state.show })
        Event.emit('toggle_sidebar', this.state.show);
    }

    desktop = () => {
        const { t, tab } = this.props;
        return (
            <div >
            <div className="d-flex justify-content-between logged-in-user" id={'topbar2'}>
                <div className='d-flex justify-content-left'>
                <Logo brand={BRAND} /><Wallet t={t} /><a href='tel:0745591262' className='phone-header'><span><i className='mdi mdi-phone mr-2 '></i></span></a>
                </div>
              
            <div className='d-flex justify-content-right'>
            <Credit t={t} /> <User t={t}/>
            </div>
            
        </div>

                   {tab && (
          <ul className="casino nav nav-pills nav-fill my-2 mx-1 d-none">
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "aviator" ? "active" : ""}`}
                href="/"
              >
                AVIATOR
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "sports" ? "active" : ""}`}
                href="/sports">
                SPORTS
              </a>
            </li>
           
          </ul>
        )}
        </div>
        );

    }

    mobile = () => {
        const { t, tab } = this.props;
        return (
            <div id={'topbar3'}>
            <div className="d-flex justify-content-between" id={'topbar2'}>
                <div className='d-flex justify-content-left'>
                <Favicon brand={BRAND} /> <Wallet t={t} />  <a href='tel:0745591262' className='phone-header-mobile'><span><i className='mdi mdi-phone'></i></span></a>
                </div>
                
                            
                            <div className='d-flex justify-content-right'>
                            <CreditMobile t={t} /><RealTime t={t} />
                            <User t={t}/>
                            </div>
                            
                        </div>


 {tab && (
          <ul className="casino nav nav-pills nav-fill mx-1 my-2 d-none">
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "aviator" ? "active" : ""}`}
                href="/"
              >
                AVIATOR
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${tab === "sports" ? "active" : ""}`}
                href="/sports">
                SPORTS
              </a>
            </li>
           
          </ul>
        )}
        </div>
                
        );
    }

    render() {
        return this.state.header;
    }
}

export default Header;